import comp from "./ManageSetsForSnP";
export default comp;
